import { graphql } from '@apollo/client/react/hoc';
import saveCallbackForm from './saveCallbackForm.graphql';
import component from './component';

export default graphql(saveCallbackForm, { name: 'handleSubmit' })(component);
